import { SVGProps } from 'react';

export const Undo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1281 1.5C6.59748 1.5 3.60299 3.726 2.60798 6.7815L1.36342 4.72875L0 5.47875L2.75518 10.0245L7.52716 7.3995L6.73996 6.1005L4.00997 7.602C4.67358 4.9665 7.16111 3 10.1281 3C13.6004 3 16.4256 5.69175 16.4256 9C16.4256 12.3082 13.6004 15 10.1281 15V16.5C14.4686 16.5 18 13.1355 18 9C18 4.8645 14.4686 1.5 10.1281 1.5Z"
      fill="currentColor"
    />
  </svg>
);
